import EventHubMixin from '@/mixins/EventHub.js'
import ScrollMixin from '@/mixins/Scroll.js'
import SizesMixin from '@/mixins/Sizes.js'

import AppHeaderLogo from '@/components/app-header-logo'
import AppHeaderTrigger from '@/components/app-header-trigger'

export default
{
    name: 'app-header',

    mixins:
    [
        EventHubMixin,
        ScrollMixin,
        SizesMixin
    ],

    components:
    {
        AppHeaderLogo,
        AppHeaderTrigger
    },

    data()
    {
        return {
            overlayOpacity: 0,
            cookiesOffset: false,
            animated: false
        }
    },

    created()
    {
        this.$eventHub.$on('cookies.active', () =>
        {
            this.cookiesOffset = true
            this.animated = true
        })

        this.$eventHub.$on('cookies.inactive', () =>
        {
            this.cookiesOffset = false

            window.setTimeout(() =>
            {
                this.animated = false
            }, 300)
        })
    },

    methods:
    {
        onScroll()
        {
            this.overlayOpacity = Math.max(Math.min(this.scroll.current / this.sizes.height * 2, 1), 0) * 0.5
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-header/script.js